import { render } from "./ContractInfo.vue?vue&type=template&id=0ea1f776&ts=true"
import script from "./ContractInfo.vue?vue&type=script&lang=ts"
export * from "./ContractInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__